module.exports = __webpack_public_path__ + "static/media/2_.caa3def1.jpeg";